import { render, staticRenderFns } from "./input-seats.vue?vue&type=template&id=f835d77e&"
import script from "./input-seats.vue?vue&type=script&lang=js&"
export * from "./input-seats.vue?vue&type=script&lang=js&"
import style0 from "./input-seats.vue?vue&type=style&index=0&id=f835d77e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports